// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearcherList-cls1_UK2","cls2":"ResearcherList-cls2_jvy ResearcherList-cls1_UK2"};